/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input, Output, Inject, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Iceutility } from '../../services/iceutility';
import { IcecontrolSettings, iceColumnDefinition, IcecontrolPermission, PaymentMethods } from '../../components/models/icesettings';
import { IcepanelComponent } from '../icepanel/icepanel.component';
import { IcematgridComponent } from '../icepanel/icematgrid.component';
import { userTypes } from '../../login/login.config';
import { MatProgressSpinnerModule } from '@angular/material';
import { licenseobject } from '../../models/domain/license';
import { LogReport } from '../../models/system/LogReport';
import { MessageService } from '../../services/message/message.service';
import { IceTypes } from '../../models/icetypes';

@Component({
  selector: 'icesubscriptionpayment',
  templateUrl: './icesubscriptionpayment.component.html',
  styleUrls: ['./icesubscriptionpayment.component.scss']
})
export class IcesubscriptionpaymentComponent implements OnInit {
  // Input Members
	@Input() placeholder: string;
  @Input() properties: any;
  @Input() ctrl: IcecontrolSettings = null;

  // Output Members
  @Output() buttonChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() buttonClick: EventEmitter<any> = new EventEmitter<any>();

  // Data Members
  iceFormControl: FormControl = null;
  paymentGroup: FormGroup = null;

  paymentMethods: any[] = [];
  selectedPaymentOfMethod: number = PaymentMethods.pmCreditCard;

  bankAccountTypes: any[] = [
    { value: "CK", name: "Personal Checking" },
    { value: "SA", name: "Personal Savings" },
    { value: "BC", name: "Business Checking" },
  ];
  selectedBankAccountType: string = "CK";
  disablePayNow: boolean = true;
  defaultPayNowDisabledStyle: any = { "background-color": "gray" };
  payNowStyle: any = this.defaultPayNowDisabledStyle;

  fieldsEntered: any = {};
  alertText: string = "";
  payNowButtonCaption: string = "Pay Now";

  dateOfPaymentCtrl: IcecontrolSettings = null;

  constructor(@Inject(IcepanelComponent) private parent: IcepanelComponent,
    private msgSvc: MessageService) {
  }

	ngOnInit() {
    try {
      // stardard formcontrol processing
      if (this.ctrl != null)
        this.iceFormControl = this.ctrl.getFormControl();

      if (this.iceFormControl == null)
        this.iceFormControl = new FormControl(false); // No control so we create a placeholder control to prevent an errors


      let controls = {};

      if (this.ctrl != null && this.ctrl.properties != null && this.ctrl.properties.paymentMethods != null && this.ctrl.properties.paymentMethods.length > 0) {
        for (let meth = 0; meth < this.ctrl.properties.paymentMethods.length; meth++) {
          let m = this.ctrl.properties.paymentMethods[meth];
          switch (m) {
            case PaymentMethods.pmCash:
              this.paymentMethods.push({ value: PaymentMethods.pmCash, name: "Cash-Pay" });
              this.selectedPaymentOfMethod = PaymentMethods.pmCash;
              this.payNowButtonCaption = "Post Money Collected";
              this.dateOfPaymentCtrl = new IcecontrolSettings("icedatepicker", { width: "200px" }, null, null, "DateOfPayment", "Date of Payment")
                .setControlName("DateOfPayment")
                .createFormControl(Iceutility.GetLocalDate(), [Validators.required]);
              break;
            case PaymentMethods.pmCreditCard:
              this.paymentMethods.push({ value: PaymentMethods.pmCreditCard, name: "Credit Card" });
              break;
            case PaymentMethods.pmBankAccount:
              this.paymentMethods.push({ value: PaymentMethods.pmBankAccount, name: "Bank Account" });
              break;
          }
        }
      }
      else {
        this.paymentMethods.push({ value: PaymentMethods.pmCreditCard, name: "Credit Card" });
        this.paymentMethods.push({ value: PaymentMethods.pmBankAccount, name: "Bank Account" });
      }

      controls["paymentMethod"] = new FormControl(this.paymentMethods[0].value);
      controls["cardNumber"] = new FormControl("");
      controls["cardHolder"] = new FormControl("");
      controls["cardExpires"] = new FormControl("");
      controls["cardCode"] = new FormControl("");

      controls["bankAccountType"] = new FormControl(this.bankAccountTypes[0].value);
      controls["bankName"] = new FormControl("");
      controls["bankAccountNumber"] = new FormControl("");
      controls["bankRoutingNumber"] = new FormControl("");
      controls["bankAccountHolder"] = new FormControl("");

      this.paymentGroup = new FormGroup(controls);

      setTimeout(() => { this.isPaymentInfoComplete() });
    }
    catch (e) {
      console.log(e);
    }
  }

  getPurchaseCaption(): string {
    if (this.ctrl != null && this.ctrl.properties != null && this.ctrl.properties.purchaseCaption != null) {
      return this.ctrl.properties.purchaseCaption;
    }

    return "Purchase Summary";
  }
  getPurchaseOptions(): any[] {
    return this.ctrl != null ? this.ctrl.getOptions() : [];
  }

  getPurchaseOption(opt: any, attr: string): string {
    if (opt == null) return "";
    let val = "";
    switch (attr) {
      case "title": {
        val = opt["title"];
        break;
      }
      case "features": {
        val = opt["features"];
        break;
      }
      case "image": {        
        val = opt["temp_image"] == null || opt["temp_image"].length == 0 ? "./assets/networks-professional.PNG" : opt["temp_image"];
        break;
      }
      case "rate": {
        val = opt["rate"].toString() + " " + this.getCurrency();
        break;
      }
    }
    return val;
  }

  getPurchaseOptionDisabled(opt: any) {
    return Iceutility.toBoolean(opt.disabled);
  }

  getPurchaseChecked(opt: any): boolean {
    if (opt == null) return false;
    return opt.license_id == 1;
  }

  getLicenseLimits(opt: any): string[] {
    let lic: licenseobject = <licenseobject>opt;
    return lic.getSummary();
  }

  getPaymentMethodImage() {
    let url = "";
    switch (this.selectedPaymentOfMethod) {
      case PaymentMethods.pmCreditCard:
        url = "./assets/CreditCards.png";
        break;
      case PaymentMethods.pmBankAccount:
        url = "./assets/RoutingAccountNumber.png";
        break;
    }
    return url;
  }

  getProductImage() {
    let url = "./assets/networks-professional.PNG";
    return url;
  } 

  getTotal(fld: string): number {
    let val = 0.0;
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return 0.0;
    }

    switch (fld) {
      case "subtotal":
        if (this.ctrl.properties.subTotal != null)
          val = this.ctrl.properties.subTotal;
        break;
      case "otherfees":
        if (this.ctrl.properties.otherFees != null)
          val = this.ctrl.properties.otherFees;
        break;
      case "total":
        if (this.ctrl.properties.grandTotal != null)
          val = this.ctrl.properties.grandTotal;
        break;
    }
    return val;
  }

  getLastErrors(): string[] {
    let ret = [];
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null || this.ctrl.properties.lastErrors == null) {
      return ret;
    }

    let errObj = this.ctrl.properties.lastErrors;
    if (errObj == null) return ret;

    let logRpts: LogReport[] = <LogReport[]>errObj.logReports;
    if (logRpts == null) return ret;

    for (let ir = 0; ir < logRpts.length; ir++) {
      let rep = logRpts[ir];
      for (let iL = 0; iL < rep.LOGS.length; iL++) {
        let log = rep.LOGS[iL];
        if (log == null) continue;

        ret.push(log.message);
      }
    }
    return ret;
  }

  getCurrency(): string {
    let val = "USD";
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return val;
    }

    val = this.ctrl.properties.defaultCurrency;
    return val;
  }

  getPayNowStyle() {
    return this.payNowStyle;
  }

  getInputClass(id: string): any {
    let cls = { "input-field": true };
    if (this.fieldsEntered[id] == true && this.getFieldValue(id) == "") {
      cls["input-validation-error"] = true;
    }
    switch (id) {
      case "cardNumber": {
        // additional validations numbers, formats, etc... 
        break;
      }
    }
    return cls;
  }

  private getFieldValue(id: string): string {
    let val = "";
    let elem: HTMLElement = document.getElementById(id);
    if (elem) val = elem["value"];

    return val;
  }

  private isPaymentInfoComplete(): boolean {
    let fldsComplete = false;
    if (this.selectedPaymentOfMethod == PaymentMethods.pmCreditCard) {
      fldsComplete = this.getFieldValue("cardNumber") != ""
        && this.getFieldValue("cardHolder") != ""
        && this.getFieldValue("cardExpires") != ""
        && this.getFieldValue("cardCode") != "";
    }
    else if (this.selectedPaymentOfMethod == PaymentMethods.pmBankAccount) {
      fldsComplete = this.getFieldValue("bankName") != ""
        && this.getFieldValue("bankAccountNumber") != ""
        && this.getFieldValue("bankRoutingNumber") != ""
        && this.getFieldValue("bankAccountHolder") != "";
    }
    else if (this.selectedPaymentOfMethod == PaymentMethods.pmCash) {
      fldsComplete = true;
    }

    let optList = this.ctrl.getOptions().filter(o => 1 == o.license_id);
    if (optList.length > 0 && fldsComplete) {
      this.disablePayNow = false;
      this.payNowStyle = {};
      return true;
    }
    this.disablePayNow = true;
    this.payNowStyle = this.defaultPayNowDisabledStyle;
    return false;
  }

  getFormGroup(): FormGroup {
    let formGrp: FormGroup = null;
    try {
      if (this.paymentGroup == null) // to prevent from getting form error we create an empty group place
        formGrp = new FormGroup({});
      else
        formGrp = this.paymentGroup;
    }
    catch (e) {
      console.log(e);
    }

    return formGrp;
  }

  getFormControl(name: string): FormControl {
    let formCtrl = null;
    if (this.paymentGroup == null) {
      try {
        formCtrl = new FormControl();
      }
      catch (e) {
        console.log(e);
      }
    }
    else {
      formCtrl = this.paymentGroup.get(name);
    }
    return formCtrl;
  }

  onInputFocusOut(event, id: string) {
    this.fieldsEntered[id] = true;
    setTimeout(() => {
      this.isPaymentInfoComplete()
    });
  }

  onKeypressNumbersOnly(event, id: string) {
    var charCode = (event.which) ? event.which : event.keyCode;

    if (charCode == 46) {
      return false;
    } else {
      if (charCode > 31
        && (charCode < 48 || charCode > 57))
        return false;
    }

    if (this.getFieldValue(id) == "" && event.currentTarget.value != "") {
      this.fieldsEntered[id] = true;
      setTimeout(() => { this.isPaymentInfoComplete() });
    }
    else if (this.getFieldValue(id) == "" || event.currentTarget.value == "") {
      if (this.fieldsEntered[id] != true) {
        this.fieldsEntered[id] = true;
        setTimeout(() => { this.isPaymentInfoComplete() });
      }
    }
    return true;
  }

  onKeypress(event, id: string) {
    if (this.getFieldValue(id) == "" && event.currentTarget.value != "") {
      this.fieldsEntered[id] = true;
      setTimeout(() => { this.isPaymentInfoComplete() });
    }
    else if (this.getFieldValue(id) == "" || event.currentTarget.value == "") {
      this.fieldsEntered[id] = true;
      setTimeout(() => { this.isPaymentInfoComplete() });
    }
    return true;
  }

  onPurchaseChange(event, opt: any) {
    event.buttonSettings = this.ctrl;
    event.buttonOptionChanged = opt;
    event.buttonAction = "OptionChange";
    opt.license_id = event.checked ? 1 : -1;

    this.isPaymentInfoComplete();

    if (this.parent && (this.parent.sections != null && this.parent.sections.length > 0) && this.parent.controlChange)
      this.parent.onControlChange(event);
    else
      this.buttonChange.emit(event);

    // emit to control observers
    if (this.ctrl.getChangeControlEvent() != null) {
      this.ctrl.getChangeControlEvent().emit(event);
    }
  }

  onPaymentMethodChange(event) {
    this.isPaymentInfoComplete();
    if (event.value == PaymentMethods.pmCash) {
      this.payNowStyle = {};
      this.payNowButtonCaption = "Post Money Collected";
      this.dateOfPaymentCtrl = new IcecontrolSettings("icedatepicker", { width: "200px" }, null, null, "DateOfPayment", "Date of Payment")
        .setControlName("DateOfPayment")
        .createFormControl(Iceutility.GetLocalDate(), [Validators.required]);
    }
    else {
      this.payNowButtonCaption = "Pay Now";
      this.dateOfPaymentCtrl = null;
    }
  }

  onCancelClick(event) {
    event.buttonSettings = this.ctrl;
    event.buttonAction = "CancelPayment";

    if (this.parent && (this.parent.sections != null && this.parent.sections.length > 0) && this.parent.controlClick)
      this.parent.onControlClick(event);
    else
      this.buttonClick.emit(event);

    // emit to control observers
    if (this.ctrl.getClickControlEvent() != null) {
      this.ctrl.getClickControlEvent().emit(event);
    }
  }

  onPayNowClick(event) {
    event.buttonSettings = this.ctrl;
    event.buttonAction = "ProcessPayment";
    if (this.dateOfPaymentCtrl != null) event.dateOfPaymentSettings = this.dateOfPaymentCtrl;

    setTimeout(() => {
      event.paymentGroup = this.paymentGroup;
      if (this.isPaymentInfoComplete()) {
        if (this.parent && (this.parent.sections != null && this.parent.sections.length > 0) && this.parent.controlClick)
          this.parent.onControlClick(event);
        else
          this.buttonClick.emit(event);

        // emit to control observers
        if (this.ctrl.getClickControlEvent() != null) {
          this.ctrl.getClickControlEvent().emit(event);
        }
      } else {
        this.msgSvc.logMessage(IceTypes.LOGTYPE.ltError, "Payment info incomplete");
      }
    });
  }
}
